<template>
  <div class="register-wrap">
    <authLeft/>
    <div class="register-right">
      <div class="register-form">
        <div class="data-table-list-nolist">
          <img src="../../assets/flow_1.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:900; margin-bottom:10px;">{{ maintenance_title }}</div>
          <div style="margin-bottom: 30px;">
            <pre>{{ maintenance_description }}</pre></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const maintenanceAPI = root + "/api/admin/maintenance";

export default {
  name: "maintenance",
  components: {
    authLeft
  },
  data() {
    return {
      maintenance_title: "",
      maintenance_description: "",
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.axios
        .get(maintenanceAPI)
        .then((response) => {
          this.maintenance_title = response.data.maintenance.maintenance_title
          this.maintenance_description = response.data.maintenance.maintenance_description
        })
        .catch(() => {});
    },
  },
};
</script>
